import { render } from "./dashboardChart.vue?vue&type=template&id=6232d823&scoped=true"
import script from "./dashboardChart.vue?vue&type=script&lang=js"
export * from "./dashboardChart.vue?vue&type=script&lang=js"

import "./dashboardChart.vue?vue&type=style&index=0&id=6232d823&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6232d823"]])

export default __exports__